import { Col, Row, Spin } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  ORDER_STATUS_CANCELLING,
  ORDER_STATUS_COLOR,
  ORDER_STATUS_LABEL,
  ROUTER_PATH,
} from "../../common/constant";
import { localizeRouteKey } from "../../shared/helpers";

const OrderItem = (props: any) => {
  const [loading, setLoading] = useState(false);
  const { order } = props;
  const { t } = useTranslation();

  const handleHeart = (code: string) => {
    console.log("code: ", code);
    setLoading(true);
  };

  return (
    <div className="order-item-container">
      {loading ? (
        <Spin />
      ) : (
        <Link
          to={`${localizeRouteKey(ROUTER_PATH.ORDERS)}/${order._id}`}
          className="order-item-info"
          onClick={() => handleHeart(order._id)}>
          <Row
            justify="space-between"
            align="middle"
            className="item-info-content">
            <Col lg={11} sm={11} xs={24}>
              <span className="main-content item-order-title">
                {order.order_title}
              </span>
              <div className="item-order-row">
                <span className="main-content">
                  {t("order_id")}:&nbsp;{order.kde_order_id}
                </span>
              </div>
            </Col>
            <Col lg={9} sm={9} xs={24}>
              <div className="item-order-row">
                <span className="main-content">
                  {t("order_date")}:&nbsp;
                  {moment(order.created_at).format(t("order_format_date"))}
                </span>
              </div>
              <div className="item-order-row">
                <span className="main-content">{t("order_status")}:&nbsp;</span>
                <span
                  className="main-content item-order-status"
                  style={{
                    color:
                      order.order_status_reject && !order.rejected
                        ? ORDER_STATUS_COLOR[ORDER_STATUS_CANCELLING]
                        : ORDER_STATUS_COLOR[order.order_status],
                  }}>
                  {order.order_status_reject && !order.rejected
                    ? ORDER_STATUS_LABEL[ORDER_STATUS_CANCELLING]
                    : order.order_status_label}
                </span>
              </div>
            </Col>
            <Col lg={4} sm={4} xs={24}>
              <Row justify="end">
                <Col>
                  <span className="sub-content item-order-view-detail-text">
                    Xem chi tiết
                    {/* &rarr; */}
                  </span>
                </Col>
                <Col>
                  <img
                    src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1624267687-Iconmuitenxam-16-16.png"
                    alt=""
                    className="item-order-view-detail-arrow"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          {/* <div className="item-info-content"></div> */}
        </Link>
      )}
    </div>
  );
};

export default OrderItem;
